import { ComponentProps } from 'react';
import Image from '@inbox-demo-nx/ui-image';
import { useDripsyTheme } from 'dripsy';
export default function ImageAvatar({
  size,
  style,
  ...props
}: { size: number } & ComponentProps<typeof Image>) {
  const { theme } = useDripsyTheme();
  return (
    <Image
      style={[
        {
          width: size,
          height: size,
          borderRadius: size / 2,
          overflow: 'hidden',
          backgroundColor: theme.colors.avatarBackground,
        },
        style,
      ]}
      resizeMode="cover"
      {...props}
    />
  );
}
